import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'wordCount',
    standalone: false
})
export class WordCountPipe implements PipeTransform {
  transform(inputText: string): number {
    return inputText ? (inputText.replace(/['";:,.?¿\-!¡]+/g, '').match(/\S+/g) || []).length : 0    
  }
}